module.exports = __webpack_public_path__ + "static/media/oasovw.47e65fe9.jpg";